import { useMutation, UseMutationResult, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { useApiClient } from '@/context/ApiClientContext/useApiClient.ts';
import { get_automation_portal_logo_url } from '@/utils/urls.ts';
import { AUTOMATION_PORTAL_KEY } from '@/utils/queryKeys.ts';
import { AutomationPortal } from '@/types/automations.ts';

type RemoveAutomationPortalLogoParams = {
  automationId: string;
};

const useRemoveAutomationPortalLogo = (): UseMutationResult<
  AutomationPortal,
  AxiosError,
  RemoveAutomationPortalLogoParams
> => {
  const apiClient = useApiClient();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ automationId }: RemoveAutomationPortalLogoParams) => {
      const response = await apiClient.delete(get_automation_portal_logo_url(automationId));
      return response.data;
    },
    onSuccess: async (portal: AutomationPortal) => {
      queryClient.setQueryData(AUTOMATION_PORTAL_KEY(portal.automation_id), portal);
      await queryClient.invalidateQueries({
        queryKey: AUTOMATION_PORTAL_KEY(portal.automation_id),
      });
    },
  });
};

export default useRemoveAutomationPortalLogo;
